const ttl = 10 * 60 * 1000; // 10min

type TCacheData<T> = {
    data: T;
    expiry: number;
};

const loadFromCache = <T>(key: string): T | null => {
    try {
        const jsonData = window.sessionStorage.getItem(key);
        if (jsonData) {
            const cacheData = JSON.parse(jsonData) as TCacheData<T> | null;
            if (cacheData && cacheData.expiry > Date.now()) {
                return cacheData.data;
            }
        }
    } catch (err) {
        // ignore
    }
    return null;
};

const saveToCache = <T>(key: string, data: T) => {
    try {
        const cacheData: TCacheData<T> = {
            data,
            expiry: Date.now() + ttl,
        };
        window.sessionStorage.setItem(key, JSON.stringify(cacheData));
    } catch (err) {
        // ignore
    }
};

const removeFromCache = (key: string) => {
    try {
        window.sessionStorage.removeItem(key);
    } catch (err) {
        // ignore
    }
};

export const useSearchResultsCache = () => ({
    loadFromCache,
    saveToCache,
    removeFromCache,
});
